export const images = [
    { id:1, original: '/images/services/1/sub-categories/1/c1-s1-p1.jpg' },
]
